import {
  FormHelperText,
  InputBaseComponentProps,
  TextFieldProps
} from '@material-ui/core';
import FormControl, { FormControlProps } from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import React, { FC } from 'react';
import MaskedInput from 'react-text-mask';

const PhoneInput: FC<InputBaseComponentProps> = (
  props: InputBaseComponentProps
) => {
  const { inputRef, ...others } = props;

  return (
    <MaskedInput
      {...others}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        '(',
        /\d/,
        /\d/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/
      ]}
      placeholderChar={'\u2000'}
      guide
    />
  );
};

type PhoneTextFieldProps = TextFieldProps & {
  errorMessage?: string;
  label?: string;
};

const PhoneTextField: FC<PhoneTextFieldProps> = props => {
  const { value, onChange, name, id, errorMessage, label, ...others } = props;
  let formProps = others as FormControlProps;
  const displayLabel = label ?? 'Phone';
  return (
    <FormControl {...formProps}>
      <InputLabel shrink htmlFor={name || 'phone'}>
        {displayLabel}
      </InputLabel>
      <Input
        value={value}
        onChange={onChange}
        id={id}
        name={name || 'phone'}
        inputComponent={PhoneInput}
      />
      <FormHelperText>{errorMessage}</FormHelperText>
    </FormControl>
  );
};

export default PhoneTextField;
